import { WorkInjuryEmployerLiabilityBundle } from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { CoverageLimit, CoverageLimitType } from "@wingspanhq/wingspan-api-sdk";

export const selectorWorkersCompLimitReverse = (
  limits: CoverageLimit[]
): WorkInjuryEmployerLiabilityBundle | undefined => {
  const eachAccident = limits.find(
    l => l.limitType === CoverageLimitType.EMPLOYERS_LIABILITY_EACH_ACCIDENT
  );
  const diseasePolicyLimit = limits.find(
    l =>
      l.limitType === CoverageLimitType.EMPLOYERS_LIABILITY_DISEASE_POLICY_LIMIT
  );

  if (!eachAccident || !diseasePolicyLimit) {
    return undefined;
  }

  const accidentAmount = eachAccident.amount;
  const diseaseAmount = diseasePolicyLimit.amount;

  if (accidentAmount === 1000000 && diseaseAmount === 1000000) {
    return WorkInjuryEmployerLiabilityBundle.OneMillionBundle;
  }

  if (accidentAmount === 1000000 && diseaseAmount === 500000) {
    return WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred;
  }

  if (accidentAmount === 500000 && diseaseAmount === 500000) {
    return WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred;
  }

  return undefined;
};
